import classNames from 'classnames'
import { Visibility } from 'globalTypes'

import { gql, useQuery } from '@apollo/client'
import {
  faGlobe,
  faUser,
  faUsers,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getItemVisibility } from 'lib/get-item-visibility'

import styles from './index.module.css'

interface ItemVisibilityProps {
  id: string
  iconClassName?: string
  visibility?: Visibility
  wrapperClassName?: string
}

const GET_ELEMENT_VISIBILITY = gql`
  query GetElementVisibility($id: ID!) {
    element(id: $id) {
      __typename

      ... on Collection {
        id
        visibility
        need_registration
      }

      ... on Content {
        id
        visibility
        need_registration
      }

      ... on Folder {
        id
        visibility
      }
    }
  }
`

const ItemVisibility = ({
  id,
  iconClassName,
  visibility,
  wrapperClassName,
}: ItemVisibilityProps) => {
  const { data, loading } = useQuery(GET_ELEMENT_VISIBILITY, {
    variables: {
      id: id,
    },
    fetchPolicy: 'cache-first',
  })

  const curVisibility = getItemVisibility(
    data?.element?.visibility,
    data?.element?.need_registration
  )

  const icons = {
    [Visibility.public]: faGlobe,
    [Visibility.preview]: faGlobe,
    [Visibility.protected]: faUsers,
    [Visibility.private]: faUsers,
    [Visibility.mine]: faUser,
    need_registration: faUserPlus,
  }

  const customWrapperClass = wrapperClassName
    ? wrapperClassName
    : styles.iconWrapperDefault

  const customIconClass = iconClassName ? iconClassName : styles.iconDefault

  return (
    <span
      className={classNames([
        styles.iconWrapper,
        customWrapperClass,
        { 'animate-pulse': loading },
      ])}
    >
      {curVisibility && (
        <FontAwesomeIcon
          icon={icons[curVisibility]}
          className={customIconClass}
        />
      )}
    </span>
  )
}

export default ItemVisibility
